import React from 'react';
import {Tag} from 'antd';
import {
    NotificationOutlined,
    TeamOutlined,
    UserDeleteOutlined,
    UserOutlined,
    WechatOutlined,
} from '@/icons';
import styles from '@/page/customer/index.module.less';

const columnDefines = () => ({
    name: {
        title: '群名',
        dataIndex: 'name',
        width: 200,
        render: name => name || '暂无群名',
    },
    ownerName: {
        title: '群主',
        width: 100,
        dataIndex: 'ownerName',
        render: (text, record) => {
            return (
                <div>
                    {text}
                    <span>({record.owner})</span>
                </div>
            );
        },
    },
    ownerType: {
        title: '群主类型',
        dataIndex: 'ownerType',
        render: ownerType => {
            if (ownerType == 2) {
                return (
                    <Tag color="blue" icon={<TeamOutlined />}>
                        企业成员
                    </Tag>
                );
            } else if (ownerType == 1) {
                return (
                    <Tag color="green" icon={<WechatOutlined />}>
                        微信客户
                    </Tag>
                );
            }
            return (
                <Tag color="blue" icon={<TeamOutlined />}>
                    其他
                </Tag>
            );
        },
    },
    notice: {
        title: '群公告',
        dataIndex: 'notice',
        render: notice => (
            <>
                {notice ? (
                    <div className={styles.word}>
                        <Tag
                            color="blue"
                            icon={<NotificationOutlined />}
                            style={{
                                maxWidth: '400px',
                                background: '#F7F9FC',
                                border: '1px solid rgba(204, 211, 237,.1)',
                            }}
                        >
                            <a title={notice} style={{color: '#152D85'}}>
                                {notice.length > 20 ? notice.substr(0, 20) + '...' : notice}
                            </a>
                        </Tag>
                    </div>
                ) : (
                    <Tag style={{color: '#999999'}}>暂无群公告</Tag>
                )}
            </>
        ),
    },
    memberName: {
        title: '群成员',
        dataIndex: 'name',
        render: (text, record) => {
            return (
                <div>
                    {text}
                    <span>({record.extId})</span>
                </div>
            );
        },
    },
    type: {
        title: '成员类型',
        dataIndex: 'type',
        render: type => {
            if (type == 1) {
                return (
                    <Tag color="blue" icon={<TeamOutlined />}>
                        企业成员
                    </Tag>
                );
            } else if (type == 2) {
                return (
                    <Tag color="green" icon={<WechatOutlined />}>
                        微信客户
                    </Tag>
                );
            }
            return '';
        },
    },
    joinScene: {
        title: '入群方式',
        dataIndex: 'joinScene',
        render: joinScene => (
            <>
                {joinScene === 1 && '直接邀请入群'}
                {joinScene === 2 && '通过邀请链接入群'}
                {joinScene === 3 && '通过扫描群二维码入群'}
            </>
        ),
    },
    status: {
        title: '状态',
        dataIndex: 'status',
        render: status => (
            <>
                {status == 1 ? (
                    <Tag color="red" icon={<UserDeleteOutlined />}>
                        已退群
                    </Tag>
                ) : (
                    <Tag color="blue" icon={<UserOutlined />}>
                        群成员
                    </Tag>
                )}
            </>
        ),
    },
});

export function getColumns(keys) {
    const defines = columnDefines();
    return keys.map(key => defines[key]).filter(Boolean);
}
